import { useEffect, useRef, useState } from "react"

const POLL_MS = 3000
const ENDPOINT = "/api/v1/public/counters"

// Polls the public counters endpoint every POLL_MS and exposes a Map
// keyed by counter name. On fetch failure, retains the last good
// snapshot — never blanks the UI.
export default function usePublicCounters() {
  const [snapshot, setSnapshot] = useState({ byName: new Map(), lastUpdated: null, error: null })
  const cancelledRef = useRef(false)

  useEffect(() => {
    cancelledRef.current = false

    const fetchOnce = async () => {
      try {
        const res = await fetch(ENDPOINT, { headers: { Accept: "application/json" } })
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        const json = await res.json()
        if (cancelledRef.current) return

        const byName = new Map()
        for (const row of json.counters || []) {
          byName.set(row.name, row)
        }
        setSnapshot((prev) => ({
          byName,
          lastUpdated: new Date(),
          error: null,
          // preserve identity of unchanged rows so memoization works
          version: (prev.version || 0) + 1,
        }))
      } catch (err) {
        if (cancelledRef.current) return
        setSnapshot((prev) => ({ ...prev, error: err.message }))
      }
    }

    fetchOnce()
    const interval = setInterval(fetchOnce, POLL_MS)
    return () => {
      cancelledRef.current = true
      clearInterval(interval)
    }
  }, [])

  return snapshot
}
